import { forwardRef } from "react";

import Stack from "@/tpo/Stack";

import { ReportListCardShell } from "./Card";
import { ReportListCardHeader } from "./Header";
import { ReportListCardMarkersAssessed } from "./MarkersAssessed";
import { ReportListCardTitle } from "./Title";
import { getReportListCardVariantStyles } from "./variantStyles";

const RelatedReportListCard = forwardRef(
  (
    {
      name,
      iconType,
      iconSize = [40, 40, 80],
      onClick,
      functionalDatapointCount,
      userReportFunctionalDatapointCount,
      dnaDatapointCount,
      userReportDnaDatapointCount,
      userReportSymptomsCount,
      symptomsCount,
      variant,
      topRightButton,
      sx
    },
    ref
  ) => {
    const { bg, color, cursor, showMarkers } = getReportListCardVariantStyles(variant);

    return (
      <ReportListCardShell
        bg={bg}
        onClick={onClick}
        ref={ref}
        data-component-name="RelatedReportListCard"
        cursor={cursor}
        p={40}
        gap={20}
        {...sx}
      >
        <Stack gap={16}>
          <ReportListCardHeader
            iconType={iconType}
            iconSize={iconSize}
            topRightButton={topRightButton}
            color={color}
          />
          <ReportListCardTitle name={name} color={color} />
        </Stack>
        {showMarkers ? (
          <ReportListCardMarkersAssessed
            functionalDatapointCount={functionalDatapointCount}
            userReportFunctionalDatapointCount={userReportFunctionalDatapointCount}
            dnaDatapointCount={dnaDatapointCount}
            userReportDnaDatapointCount={userReportDnaDatapointCount}
            symptomsCount={symptomsCount}
            userReportSymptomsCount={userReportSymptomsCount}
            color={color}
            layout="inline"
            showCircleButton={variant !== "disabled"}
          />
        ) : null}
      </ReportListCardShell>
    );
  }
);

export default RelatedReportListCard;
